export default __webpack_public_path__ + "static/calendar_and_notifications-7f12b53da4281fc0485a209a6c5e69f0.svg";